var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeSpecifiedWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 9.99967C9.99984 9.99967 7.71769 14.1663 5.4165 14.1663C3.11532 14.1663 1.6665 12.3008 1.6665 9.99967C1.6665 7.69849 3.11532 5.83301 5.4165 5.83301C7.71769 5.83301 9.99984 9.99967 9.99984 9.99967ZM9.99984 9.99967C9.99984 9.99967 12.282 14.1663 14.5832 14.1663C16.8843 14.1663 18.3332 12.3008 18.3332 9.99967C18.3332 7.69849 16.8843 5.83301 14.5832 5.83301C12.282 5.83301 9.99984 9.99967 9.99984 9.99967Z",
    stroke: "white",
    strokeWidth: 1.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSpecifiedWhite);
export default __webpack_public_path__ + "static/media/time-specified-white.a09ec969a3fabc9c474cd91fdc7fd44d.svg";
export { ForwardRef as ReactComponent };